/**
 * English translations for dashboard tips (post-registration).
 * Lightweight tips shown on first login for broker/company users.
 */

const onboarding = {
  tips: {
    inviteTeam: {
      title: 'Invite Your Team',
      description: 'Add team members to collaborate on listings and manage properties together.',
    },
    addListing: {
      title: 'Add Your First Listing',
      description: 'Create your first property listing to start attracting tenants.',
    },
    skipAll: 'Skip all tips',
    gotIt: 'Got it',
  },
};

export default onboarding;
